import { render, staticRenderFns } from "./MultipleList.vue?vue&type=template&id=c1a4c534&scoped=true&"
import script from "./MultipleList.vue?vue&type=script&lang=js&"
export * from "./MultipleList.vue?vue&type=script&lang=js&"
import style0 from "./MultipleList.vue?vue&type=style&index=0&id=c1a4c534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a4c534",
  null
  
)

export default component.exports